<button mat-flat-button color="primary" [color]="color" [class.spinner]="isSaving" [disabled]="isDisabled || isSaving">
  {{isSaving ? processingText + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : text}}</button>
